import { Part } from '@/Engine/Part';
import { $ } from '@/Engine/state';
import { Vector3 } from 'three';

export function calculateScale(obj: Part) {
    if (!obj.obb) return;
    //scale - определение справа/слева комплектующее
    //(если виртуальный курсор переместить больше, чем на половину комплектующего)
    if (obj.isLeft && $.pointerVirtual.x < obj.obb.halfSize.x ||
        !obj.isLeft && -$.pointerVirtual.x > obj.obb.halfSize.x) {
        obj.scale = new Vector3(-1, 1, 1);
    }
    if (obj.isLeft && $.pointerVirtual.x > obj.obb.halfSize.x ||
        !obj.isLeft && -$.pointerVirtual.x < obj.obb.halfSize.x) {
        obj.scale = new Vector3(1, 1, 1);
    }
}